/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetRecord } from './AssetRecord';
import {
    AssetRecordFromJSON,
    AssetRecordFromJSONTyped,
    AssetRecordToJSON,
    instanceOfAssetRecord,
} from './AssetRecord';

/**
 * 
 * @export
 * @interface ListAssetsResponseContent
 */
export interface ListAssetsResponseContent {
    /**
     * Assets owned by the calling user for this project.
     * @type {Array<AssetRecord>}
     * @memberof ListAssetsResponseContent
     */
    assets: Array<AssetRecord>;
}


/**
 * Check if a given object implements the ListAssetsResponseContent interface.
 */
export function instanceOfListAssetsResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    return isInstance;
}

export function ListAssetsResponseContentFromJSON(json: any): ListAssetsResponseContent {
    return ListAssetsResponseContentFromJSONTyped(json, false);
}

export function ListAssetsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'assets': ((json['assets'] as Array<any>).map(AssetRecordFromJSON)),
    };
}

export function ListAssetsResponseContentToJSON(value?: ListAssetsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'assets': ((value.assets as Array<any>).map(AssetRecordToJSON)),
    };
}

